import React, { useState, useEffect } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import Scheme_Allot_Dist from './Scheme_Allot_Dist';
import GetSchemes from '../../Dropdowns/getSchemes';

const Scheme_Allot_Int = ({ heading }) => {
    
     const [renderContent, setRenderContent] = useState(null);
     const [loadingMonths, setLoadingMonths] = useState(true); 
     const [loadingYears, setLoadingYears] = useState(true);  
     const [loadingScheme, setLoadingScheme] = useState(true);  
 
     
    useEffect(() => {
        if (!loadingMonths && !loadingYears) {
            const timer = setTimeout(() => {
                handleSubmit();
            }, 10);
             return () => clearTimeout(timer);
        }
    }, [loadingMonths, loadingYears, 100]); // Only run when loading states change

     const handleMonthsLoadingChange = (isLoading) => {
        setLoadingMonths(isLoading);
    };
     const handleYearsLoadingChange = (isLoading) => {
        setLoadingYears(isLoading);
    };
    const handleSchemesLoadingChange = (isLoading) => {
        setLoadingScheme(isLoading);
    };

    // Handling form submission
    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const scheme_id = document.getElementById('scheme_id').value;
        const type = document.getElementById('type').value;
 
        if (month==0 || month == null || month ==''  ) {
            alert('Please select Month');
        } else  if (year==0 || year == null || year ==''  ) {
            alert('Please select Year');          
        }     if (  scheme_id == null || scheme_id ==''  ) {
            alert('Please select Scheme');
        } else  if (type==0 || type == null || type ==''  ) {
            alert('Please select Type');          
        }    else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <Scheme_Allot_Dist 
                        month={month} 
                        year={year} 
                        scheme_id={scheme_id}
                        type = {type}
                        heading={heading} />
                );
            }, 0);
                }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleMonthsLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleYearsLoadingChange} /></td>
                                    <td>Scheme</td>
                                    <td><GetSchemes onLoadingChange={handleSchemesLoadingChange}  /></td>
                                    <td>Type</td>
                                    <td>
                                    <select name="type" id="type">
			                            <option value="REG">Regular</option>
			                            <option value="EXT">Extra</option>
		                        	</select>
                                    </td>
                                
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                    <button onClick={handleSubmit} className="button button2" disabled={loadingMonths || loadingYears || loadingScheme}>
                                    Submit
                                    </button>
                                    <button className="button button2">
                                    Back
                                    </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                     <div id="detailsER">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Scheme_Allot_Int;
